export default {
  // 模块名称
  carRecord: {
    // 按钮类
    button: {
      query: 'Query',
      reset: 'Reset',
      export: 'Export',
      close: 'Close',
      detail: 'Detail'
    },
    // 文字标签类
    label: {
      plateCode: 'Plate Code',
      name: 'Name',
      phone: 'Phone',
      idCard: 'Id Card',
      vehicleType: 'Vehicle Type',
      vehicleColor: 'Vehicle Color',
      trafficArea: 'Traffic Area',
      vehiclePhoto: 'Vehicle Photo',
      desc: 'Description',
      approvalStatus: 'Approval Status',
      approvalOpinions: 'Approval Opinions',
      operations: 'Operations',
      image: 'Image',
      workNo: 'Work No'
    },
    // 提示类
    placeholder: {
      select: 'Select',
      startDate: 'Start Date',
      endDate: 'End Date'
    },
    // 消息类
    message: {},
    // 标题类
    title: {
      detail: 'Record details'
    }
  }
}